import { FC } from 'react';

import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';

import Sidebar from './components/Sidebar';
import EmptyState from './components/EmptyState';
import Conversation from './components/Conversation';
import NoAccessState from './components/NoAccessState';
import SocietyAiAgentHeader from './components/SocietyAiAgentHeader';

import { useSocietyAiAgentPage } from './context/SocietyAiAgentPageContext';

import './SocietyAiAgent.scss';

const SocietyAiAgent: FC = () => {
  const { data } = useSocietyAiAgentPage();
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const hasAiAccess = actualSociety?.configuration?.aiPlan?.enabled === true;

  if (actualSociety && !hasAiAccess) {
    return (
      <div className="navi">
        <NoAccessState />
      </div>
    );
  }

  const hasActiveChat =
    data.messages.length > 0 || data.isThinking || !!data.streamingText;
  return (
    <div className="navi">
      <div className="navi__header">
        <SocietyAiAgentHeader />
      </div>

      <div className="navi__layout">
        <Sidebar />
        <main className="navi__main">
          {hasActiveChat ? <Conversation /> : <EmptyState />}
        </main>
      </div>
    </div>
  );
};

export default SocietyAiAgent;
